if (!rtKendo) var rtKendo = {};
if (!rtKendo.debug) rtKendo.debug = {};

rtKendo.debug.dropDownList = {
    onDataBound: function (e) {
        console.log("event :: dataBound");
        console.log(e);
    }
};

